import { render, staticRenderFns } from "./contentModal.vue?vue&type=template&id=08d7e9c8&scoped=true"
import script from "./contentModal.vue?vue&type=script&lang=js"
export * from "./contentModal.vue?vue&type=script&lang=js"
import style0 from "./contentModal.vue?vue&type=style&index=0&id=08d7e9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7e9c8",
  null
  
)

export default component.exports